import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { LogoLink } from "@/components/brand/Logo";
import { useAuth, PORTAL_PATH } from "@/lib/AuthContext";
import { NAV } from "@/data/siteContent";

const LINKS = NAV;

export function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const portalTo = user ? PORTAL_PATH[user.role] : "/login";
  const portalLabel = user ? "Go to my portal" : "Login";

  return (
    <header className="sticky top-0 z-50 border-b border-[#E6E1D8] bg-white/95 backdrop-blur-md">
      <div className="mx-auto flex max-w-[1180px] items-center justify-between px-5 py-4 lg:px-8">
        <LogoLink height={30} />

        <nav className="hidden items-center gap-7 md:flex" data-testid="public-nav-desktop">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              data-testid={`nav-link-${link.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-[15px] font-medium transition-colors ${
                  isActive ? "text-[#111111]" : "text-[#6b6660] hover:text-[#111111]"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
          <Link
            to={portalTo}
            data-testid="nav-login-button"
            className="rounded-full bg-[#F2811D] px-6 py-2.5 text-[15px] font-semibold text-white transition-colors hover:bg-[#D96E10]"
          >
            {portalLabel}
          </Link>
        </nav>

        <button
          type="button"
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="rounded-full border border-[#E6E1D8] p-2.5 md:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#E6E1D8] bg-white md:hidden" data-testid="mobile-nav">
          <div className="flex flex-col px-5 py-3">
            {LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${link.label.toLowerCase()}`}
                className={`border-b border-[#F0ECE4] py-3.5 text-base font-medium ${
                  location.pathname === link.to ? "text-[#F2811D]" : "text-[#111111]"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to={portalTo}
              onClick={() => setOpen(false)}
              data-testid="mobile-nav-login-button"
              className="mt-4 mb-2 rounded-full bg-[#F2811D] px-6 py-3 text-center text-base font-semibold text-white"
            >
              {portalLabel}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
